import React, {Component, useState} from "react";
import Subjektif from "../form/Subjektif";
import Objektif from "../form/Objektif";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { BMI, BmiCss, BloodPress, BloodPressCss } from "../form/rumus";
import "react-tabs/style/react-tabs.css";
import apiService from "apiService.js";
import ObjectiveGizi from "./ObjectiveGizi";
import PlanningGizi from "./PlanningGizi";
import AssesmentGizi from "./AssessmentGizi";
import Bbu from "../resume/Bbu";
import LingkarKepala from "../resume/LingkarKepala";
import Tbu from "../resume/Tbu";
import BbtbCharts from "../resume/BbtbCharts";
import ImtU from "../resume/ImtU";
import API from "../../apiService";
import BlobPrint from "../component/BlobPrint";

export default class Gizi extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visitId: 0,
            modules: [
                { id: "0", name: "Grafik" },
                { id: "1", name: "Subjektif" },
                { id: "2", name: "Objektif" },
                { id: "3", name: "Assesment" },
                { id: "4", name: "Planning" },
            ],
            visible: false,
            detilPx: this.props.detilPx,
            tabIndex: 0,
            histories : [],
            dataObjectiveGizi: {},
            nutrition: {}
        };
        this.parentCallback = this.parentCallback.bind(this);
        this.nextTab = this.nextTab.bind(this);
    }

    componentDidMount() {
        this.getHistories();
    }

    getHistories = async () => {
        const res = await apiService.get(
            "registration/history/" + this.props.detilPx.patients.id
        );
        if (res.code === 200) {
            let histories = res.data.histories.data.reverse();
            this.setState({
                histories: histories
            });
        }
    }

    buttonClick = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    parentCallback(data) {
        this.setState((prevState) => ({
            detilPx: {
                ...prevState.detilPx,
                [data.param]: data.data,
            },
        }));
    }

    getData = async () => {
        let param = {
            keyword: {
                visitId: this.state.detilPx.id,
            },
            limit: 10,
            frDate: "",
            enDate: "",
        };

        const res = await apiService.post("registration", param);
        if (res?.status === "success.") {
            this.setState({
                detilPx: res.data.data[0],
            });
            this.forceUpdate();
        }
    };

    nextTab() {
        const tabs = this.state.tabIndex;
        const tabIndex = tabs + 1;
        this.setState({ tabIndex: tabIndex });
        window.scrollTo(0, 50);
    }

    render() {
        var patient = this.state.detilPx;
        return (
            <div>
                <div className='card'>
                    <div className='card-header'>
                        <div className='row align-items-center'>
                            <div className='col'>
                                <span className='h3 mb-0 '>Form Pemeriksaan Gizi</span>
                                <span className='ml-2 mt--1'>
                                  <a
                                      className='btn btn-sm btn-twitter btn-icon-only rounded-circle'
                                      onClick={this.getData}>
                                    <i
                                        className='fa fa-refresh'
                                        style={{ color: "white" }}
                                        aria-hidden='true'></i>
                                  </a>
                                    <button className="btn btn-sm btn-info ml-2" onClick={() => BlobPrint('registration/letter/asuhan-gizi/' + this.state.detilPx.id)}>cetak asuhan gizi</button>
                                </span>
                            </div>
                            <div
                                className={BmiCss(
                                    patient.examinations[0].weight,
                                    patient.examinations[0].height
                                )}>
                                {BMI(
                                    patient.examinations[0].weight,
                                    patient.examinations[0].height
                                )}
                            </div>
                            <div
                                className={BloodPressCss(
                                    patient.examinations[0].sistole,
                                    patient.examinations[0].diastole
                                )}
                                style={{ marginLeft: "2%" }}>
                                <b>
                                    {" "}
                                    {BloodPress(
                                        patient.examinations[0].sistole,
                                        patient.examinations[0].diastole
                                    )}{" "}
                                </b>
                            </div>
                        </div>
                    </div>
                    <div className='card-body'>
                        <Tabs
                            selectedIndex={this.state.tabIndex}
                            onSelect={(tabIndex) => this.setState({ tabIndex })}>
                            <TabList>
                                <Tab id='Grafik'>Grafik </Tab>
                                <Tab id='Subjektif'>Subjektif </Tab>
                                <Tab id='Objektif'>Objektif </Tab>
                                <Tab id='Assesment'>Assesment </Tab>
                                <Tab id='Planning'>Planning </Tab>
                            </TabList>
                            <TabPanel tabId='Grafik'>
                                <Bbu histories = {this.state.histories} patient={patient} />
                                <LingkarKepala histories = {this.state.histories} patient={patient} />
                                <Tbu histories = {this.state.histories} patient={patient} />
                                <BbtbCharts histories = {this.state.histories} patient={patient}  />
                                <ImtU histories = {this.state.histories} patient={patient} />
                            </TabPanel>
                            <TabPanel tabId='Subjektif'>
                                <Subjektif
                                    patient={patient}
                                    parentCallback={this.parentCallback}
                                    history={this.props.history}
                                    nextTab={this.nextTab}
                                />
                            </TabPanel>
                            <TabPanel tabId='Objektif'>
                                <Objektif
                                    patient={patient}
                                    onExaminationSaved={() => {
                                        const nutrition = {
                                            ...this.state.dataObjectiveGizi,
                                        }
                                        this.setState({nutrition})
                                        console.log({nutrition})
                                        if (nutrition.id) {
                                            API.put(`/nutrition/${nutrition.visit_id}`, nutrition)
                                        }
                                        else {
                                            API.post("/nutrition", nutrition)
                                        }
                                    }}
                                    parentCallback={this.parentCallback}
                                    history={this.props.history}
                                    nextTab={this.nextTab}
                                >
                                    <ObjectiveGizi
                                        patient={patient}
                                        onDataChange={v => this.setState({dataObjectiveGizi: v})}
                                    />
                                </Objektif>
                            </TabPanel>
                            <TabPanel tabId='Assesment'>
                                <AssesmentGizi
                                    patient={patient}
                                    parentCallback={this.parentCallback}
                                    history={this.props.history}
                                    nextTab={this.nextTab}
                                />
                            </TabPanel>
                            <TabPanel tabId='Planning'>
                                <PlanningGizi
                                    patient={patient}
                                    parentCallback={this.parentCallback}
                                    history={this.props.history}
                                    nextTab={this.nextTab}
                                    nutrition={this.state.nutrition}
                                />
                            </TabPanel>
                        </Tabs>
                    </div>
                </div>
            </div>
        );
    }
}